import React, { Component } from "react";

import { initGA, logPageView } from "../googleAnalytics.js"

import { Nav, Footer, BackToTop } from "./";

// const Layout = ({ children }) => {
class Layout extends Component {
  componentDidMount () {
    if (!window.GA_INITIALIZED) {
      initGA()
      window.GA_INITIALIZED = true
    }
    logPageView()
  }

  render () {
    return (
      <>
        <Nav />
        {this.props.children}
        <BackToTop />
        <Footer />
      </>
    );
  }
};

export default Layout;
